/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import ExampleLoading from 'react-scale/components/website/index/Products/examples/exampleLoading';

const TaskResponseAnnotation = dynamic(
  () => import('react-scale/components/website/index/Products/examples/tasks/segmentannotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

export default () => (
  <TaskResponseAnnotation
    src="/static/img/website/solutions/ar-vr/slider/slide-3.jpg"
    combined="/static/img/website/solutions/ar-vr/slider/slide-3-response.png"
    responsive
    rounded
    labelMapping={{
      lamp: {
        index: 1,
        color: '#ff0000'
      },
      'small table': {
        index: 2,
        color: '#ffff00'
      },
      sofa: {
        index: 3,
        color: '#00ff00'
      },
      couch: {
        index: 4,
        color: '#00ffff'
      },
      pillow: {
        index: 5,
        color: '#ffb43c'
      },
      bookshelf: {
        index: 6,
        color: '#64823c'
      },
      window: {
        index: 7,
        color: '#0000ff'
      }
    }}
  />
);
